module.exports = __webpack_public_path__ + "static/media/BrixSans-Regular.35f5b0b6.woff";